import { getCurrentUser } from '@back-office/core';
import { http } from '../config';
import {
  GET_USER_LIST_ENDPOINT,
  UPDATE_USER_PERMISSION_ENDPOINT,
  UPDATE_USER_PHONE_ENDPOINT,
} from '../endpoints';
import { SuccessResponse, UserListResponse } from '../types';
import { User } from '../types/users';

export async function getUserList(): Promise<UserListResponse> {
  const currentUser = getCurrentUser();
  return http.get(GET_USER_LIST_ENDPOINT, {
    params: { merchantID: currentUser.merchantID },
  });
}

export async function deleteUser(email: string): Promise<SuccessResponse> {
  const currentUser = getCurrentUser();
  return http.delete(`${GET_USER_LIST_ENDPOINT}/${email}`, {
    params: { merchantID: currentUser.merchantID },
  });
}
export const updateUserPhoneNumber = async (
  email: string,
  phone: string,
  mid: string,
  merchantID: string
): Promise<SuccessResponse> =>
  http.post(`${UPDATE_USER_PHONE_ENDPOINT}?merchantID=${merchantID}`, {
    email,
    mid,
    phoneNo: phone,
  });

export const updatePermissionsNumber = async (
  email: string,
  permissionId: number,
  mid: string,
  merchantID: string
): Promise<SuccessResponse> =>
  http.post(`${UPDATE_USER_PERMISSION_ENDPOINT}?merchantID=${merchantID}`, {
    email,
    mid,
    permissionId,
  });

export const updateUserDetail = async (
  user: User,
  phone: string,
  permissionId: number[]
): Promise<SuccessResponse> => {
  const { merchantID, email, mid } = user;
  let response: Promise<SuccessResponse>;
  if (user.phone !== phone) {
    response = http.post(
      `${UPDATE_USER_PHONE_ENDPOINT}?merchantID=${merchantID}`,
      {
        email,
        mid,
        phoneNo: phone,
      }
    );
  }

  response = http.post(
    `${UPDATE_USER_PERMISSION_ENDPOINT}?merchantID=${merchantID}`,
    {
      email,
      mid,
      permissionId,
    }
  );

  return response;
};
